export default {
  'dataset-delivery.title': 'Dataset delivery',
  // Table
  'dataset-delivery.tableHeader.organization': 'Organization',
  'dataset-delivery.tableHeader.dataset': 'Dataset',
  'dataset-delivery.tableHeader.delivery-endpoint': 'Delivery endpoint',
  'dataset-delivery.tableHeader.verify': 'Verify',
  'dataset-delivery.tableHeader.verificationStatus': 'Verification status',
  'dataset-delivery.tableHeader.deliver': 'Deliver',
  'dataset-delivery.tableHeader.deliveryStatus': 'Delivery status',

  //Manifest
  'dataset-delivery-manifest.title': 'Dataset delivery detail',
  'dataset-delivery-manifest.tableHeader.file-number': 'File number',
  'dataset-delivery-manifest.tableHeader.file-name': 'File name',
  'dataset-delivery-manifest.tableHeader.file-size-bytes': 'File size (bytes)',
  'dataset-delivery-manifest.tableHeader.row-count': 'Rows',
  'dataset-delivery-manifest.tableHeader.checksum': 'Checksum',
  'dataset-delivery-manifest.description.delivery_location': 'Delivery location',
  'dataset-delivery-manifest.description.archive_size': 'Archive size',
  'dataset-delivery-manifest.description.archive_md5': 'Archive checksum',
};
